import React from 'react';

const LinkRender = (props) => {

    if (!props.link) return "JSON VALIDATION FAILED";
    let path = props.link.IsStatic && "/static_page/";
    console.log(props);
    if (!props.link.IsStatic) {
        switch (props.searcharea) {
            case "CanonEquipment":
                path = "/canon_equipment/";
                break;
            case "OfficeEquipment":
                path = "/office_equipment/";
                break;
            case "OfficeFurniture":
                path = "/office_furniture/";
                break;
            default:
                break;
        }
    }

    return (
        <div id="link-render-div">
            <a id="link-render-link" href={path + props.link.Id}>{props.link.ProductName}</a><br />
            {props.link.ProductTag1}
        </div>
    )

}

export default LinkRender;

